import { Component, Injector, OnDestroy, OnInit } from '@angular/core';

import { ToastService, RouteService } from '@kaiser-software/chassis-core';

import { LocationModel } from '../../models/location.model';
import { LocationService } from '../../services/location.service';

@Component({
    selector: 'donna-locations-index',
    templateUrl: 'index.page.html',
    styleUrls: ['index.page.scss']
})
export class LocationIndexPage implements OnInit, OnDestroy {

    /**
     * The page title.
     *
     * @type {string}
     */
    protected title = 'Locations';

    /**
     * The route prefix.
     */
    protected routePrefix = 'locations';

    /**
     * The plugin slot prefix.
     *
     * @type {string}
     */
    protected pluginPrefix = 'donna-locations';

    /**
     * The LocationModel instance.
     *
     * @type {LocationModel}
     */
    public model: LocationModel = new LocationModel;

    /**
     * The LocationService instance.
     */
    protected locationService: LocationService;

    /**
     * The RouteService instance.
     */
    protected routeService: RouteService;

    /**
     * The ToastService instance.
     */
    protected ToastService: ToastService;

    /**
     * Table object to override defaults or to add functionality.
     */
    protected table = {
        service: null,
    };

    /**
     * Constructor.
     *
     * @param injector
     */
    constructor(protected injector: Injector) {
        this.locationService     = this.injector.get(LocationService);
        this.routeService        = this.injector.get(RouteService);
        this.ToastService = this.injector.get(ToastService);
    }

    /**
     * OnInit.
     */
    ngOnInit() {
        this.createDatatable();
    }

    /**
     * Create the datatable.
     */
    protected createDatatable() {
        this.table = {
            service: this.locationService,
        };

        this.createDatatableCallbacks();
        this.createDatatableFilters();
    }

    /**
     * Set datatable callbacks.
     */
    protected createDatatableCallbacks() {
        // this.table.callbacks['click'] = (model, row, index) => {};
    }

    /**
     * Create datatable filters.
     */
    protected createDatatableFilters() {
        // this.table.filters = [];
    }

    /**
     * OnDestroy.
     */
    ngOnDestroy() {
    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/locations/pages/index/index.page.ts